import React from 'react'
import type { JobSearchFilterOption } from '../features/jobSearch/config'
import './MultiSelectChipGroup.css'

interface MultiSelectChipGroupProps {
  ariaLabel: string
  options: JobSearchFilterOption[]
  selectedValues: string[]
  onChange: (nextSelectedValues: string[]) => void
  className?: string
  dataTourId?: string
}

export const MultiSelectChipGroup: React.FC<MultiSelectChipGroupProps> = ({
  ariaLabel,
  options,
  selectedValues,
  onChange,
  className,
  dataTourId,
}) => {
  const selectedSet = new Set(selectedValues)

  const handleToggle = (value: string) => {
    if (selectedSet.has(value)) {
      onChange(selectedValues.filter((selectedValue) => selectedValue !== value))
      return
    }

    onChange(Array.from(new Set([...selectedValues, value])))
  }

  return (
    <div
      className={`multi-select-chip-group${className ? ` ${className}` : ''}`}
      role="group"
      aria-label={ariaLabel}
      data-tour-id={dataTourId}
    >
      {options.map((option) => {
        const selected = selectedSet.has(option.value)
        return (
          <button
            key={option.value}
            type="button"
            className={`multi-select-chip${selected ? ' multi-select-chip--selected' : ''}`}
            aria-pressed={selected}
            onClick={() => handleToggle(option.value)}
          >
            {option.label}
          </button>
        )
      })}
    </div>
  )
}
